import request from '@/utils/request'

export function edit(data) {
  return request({
    url: '/api/v1/structure/edit',
    method: 'post',
    data,
    loading: true
  })
}

export function statusChange(data) {
  return request({
    url: '/api/v1/structure/statusChange',
    method: 'post',
    data,
    loading: true
  })
}

export function getOrgDetail(data) {
  return request({
    url: '/api/v1/structure/findById',
    method: 'post',
    data,
    loading: true
  })
}

export const del = (data) => {
  return request({
    url: '/api/v1/structure/del',
    data,
    method: 'post'
  })
}

export function getOrgData(data) {
  return request({
    // url: '/api/v1/structure/list',
    url: '/api/v1/structure/organizationTreeList',
    method: 'post',
    data,
    loading: true
  })
}
